import type { PostSortRowsParams } from 'ag-grid-community';
import { moveInPlace } from 'utils/arrays';

export const postSort = (params: PostSortRowsParams) => {
  const addRowIndex = params.nodes.findIndex((x) => x.id === 'provisional');

  if (addRowIndex > -1) {
    moveInPlace(params.nodes.length - 1, addRowIndex, params.nodes);
  }
};
